import React from "react"

const Cards2 = ({
  width = "146",
  height = "136",
  viewBox = "0 0 146 136",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d-cards-2)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M62.3 76.351l11.915-37.045A7.64 7.64 0 0181.462 34c.773 0 1.56.121 2.333.374l8.964 2.943a13.66 13.66 0 00-2.343 2.564l-22.3 31.777c-2.11 3.005-2.932 6.668-2.318 10.314.241 1.43.694 2.785 1.332 4.036-3.944-1.326-6.117-5.657-4.83-9.657zm18.573-31.047l1.48.55.282-7.168-1.581-.587-4.38 5.645 1.481.55.81-1.112 2 .743-.092 1.379zm-27.807-2.895V81.36c0 4.085 3.105 7.28 7.086 7.488-1.155-1.09-2.096-2.386-2.836-3.853a13.854 13.854 0 01-.814-10.544l11.923-37.123c.182-.566.401-1.028.65-1.553.168-.355.35-.739.544-1.203h-8.996c-4.181 0-7.556 3.612-7.556 7.836zm9.765 3.3h-1.912l-1.512-2.689h-1.018v2.688h-1.52v-6.911h1.52v2.688h.828l1.484-2.688h1.949l-2.093 3.132 2.274 3.78zm-29.216 6.184c-1.292-4.017.904-8.372 4.88-9.677l8.902-2.942c-.226 1.008-.413 2.057-.413 3.135v38.952c0 5.638 3.33 10.402 8.082 12.5l.043.008a7.46 7.46 0 01-2.333.374 7.638 7.638 0 01-7.246-5.304L33.615 51.893zm5.681-1.665l2.315 2.088 1.807-.631-3.357-2.78.98-3.61-1.843.642-.54 3.016-.504.176-.864-2.525-1.486.518 2.206 6.45 1.487-.518-.885-2.587.684-.239zm.45 40.606c1.454 4.521 5.04 7.868 9.425 9.067a7.511 7.511 0 01-2.926.596 7.582 7.582 0 01-6.219-3.23l-22.3-31.777c-2.418-3.447-1.606-8.264 1.805-10.707l7.635-5.468c-.023 1.48.188 2.987.665 4.471l11.915 37.048zm-16.73-29.133l2.797 1.359 1.564-1.112-3.988-1.733-.048-3.743-1.594 1.133.308 3.048-.437.31-1.522-2.184-1.286.914 3.887 5.582 1.287-.915-1.56-2.238.592-.421zM81.23 40.12l-.173 2.539-1.345-.5 1.492-2.048.026.01zm45.238 16.165L105.977 41.61a7.495 7.495 0 00-4.38-1.407 7.583 7.583 0 00-6.218 3.23l-22.3 31.776c-2.419 3.447-1.607 8.264 1.804 10.707l20.491 14.676a7.493 7.493 0 004.38 1.407 7.583 7.583 0 006.218-3.23l22.301-31.777c2.418-3.447 1.606-8.265-1.805-10.707zm-24.73-12.92l1.373.986-2.128 6.842-1.287-.922.446-1.307-1.737-1.246-1.07.86-1.287-.923 5.69-4.29zm.043 39.394c4.442 1.427 13.75-3.706 6.27-22.323-19.865-.99-21.59 9.58-18.791 13.345 1.55 2.084 3.485 2.79 5.394 2.584l-3.41 4.158 3.582 2.568 2.89-4.841c.4 1.964 1.53 3.694 4.065 4.509zm-.4-37.396l-.824 2.404-1.169-.839 1.971-1.58.022.015z"
          fill="#DB1616"
        />
      </g>
      <defs>
        <filter
          id="filter0_d-cards-2"
          x="-11"
          y="-16"
          width="168"
          height="168"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix values="0 0 0 0 0.766667 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export default Cards2
